module.exports = __webpack_public_path__ + "static/media/David.d7ce440b.jpg";